import { container } from "tsyringe";
export class UseCaseCategoryConfig {
    async getCategoryConfig() {
        const _GetCategoryConfig = container.resolve("iGetCategoryConfig");
        const categoryConfig = await _GetCategoryConfig.getCategoryConfig();
        return categoryConfig;
    }
}
